export enum Katalog {
	ABTEILUNGEN,
	BESCHAEFTIGUNGSARTEN,
	BETRIEBE,
	BETRIEBSARTEN,
	EINSCHULUNGSARTEN,
	EINWILLIGUNGSARTEN,
	ENTLASSGRUENDE,
	ERZIEHERARTEN,
	FAECHER,
	FAHRSCHUELERARTEN,
	FLOSKELGRUPPEN,
	FLOSKELN,
	FOERDERSCHWERPUNKTE,
	HALTESTELLEN,
	JAHRGAENGE,
	KINDERGAERTEN,
	RELIGIONEN,
	LERNPLATTFORMEN,
	ORTE,
	ORTSTEILE,
	SCHULEN,
	TELEFONARTEN,
	VERMERKARTEN
}
